import React from "react";
import { useSite } from "../context/SiteContext";
import useReveal from "../hooks/useReveal";
import Crest from "./Crest";

export default function Kindred({ pledges }) {
  useReveal();
  const { c } = useSite();
  const { kindred, ui } = c;
  return (
    <section id="kindred" className="bg-ink py-28 sm:py-40">
      <div className="max-w-[1220px] mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="eyebrow">{kindred.label}</span>
          <h2 className="font-display text-4xl sm:text-6xl font-light text-parchment mt-5">{kindred.title}</h2>
          <p className="mt-4 text-lg text-parchment/60 font-light">{kindred.text}</p>
          <p className="font-label text-[0.72rem] uppercase tracking-[0.24em] text-gold mt-6">
            {pledges.length} {pledges.length === 1 ? ui.nameSing : ui.namePlur} {ui.pledged}
          </p>
        </div>

        {pledges.length === 0 ? (
          <div className="mt-16 flex flex-col items-center text-center">
            <Crest size={56} className="opacity-40" />
            <p className="mt-6 font-display italic text-2xl text-parchment/40">
              {ui.noNames}
            </p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--c-border)] mt-16">
            {pledges.map((p, i) => (
              <div key={i} className="reveal in-view bg-ink px-7 py-6 flex items-center gap-4">
                <span className="font-display text-2xl text-gold/50 w-10">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <p className="font-display text-2xl text-parchment leading-tight">{p.name}</p>
                  {p.place && (
                    <p className="font-label text-[0.64rem] uppercase tracking-[0.18em] text-stone2 mt-1">{p.place}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
